import React, { Component } from 'react';
import { View, TouchableOpacity, SafeAreaView, Image, ActivityIndicator } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Heading from '../components/Heading';
import RF from '../tools/RF';
import axios from 'axios';

export default class NewBusiness extends Component {

    constructor(props) {
        super(props);
        this.state = {
            details: this.props.route.params.details,
            sick: this.props.route.params.sick,
            highTemprature: this.props.route.params.highTemprature,
            pin: this.props.route.params.pin
        };
    }

    componentDidMount() {
        console.log(this.state);
    }

    render() {

        let pin = (
            <View style={{ width: '100%', alignItems: 'center', padding: 10, marginTop: 10, backgroundColor: '#FAFAFA' }}>
                <View style={{ width: "100%", marginBottom: 5 }}>
                    <Heading text="Verification PIN" color="#999" textAlign="center" fontSize={RF(2.0)} fontFamily="NunitoExtraBold" inline={true} />
                </View>
                <View style={{ width: "100%" }}>
                    <Heading text={this.state.pin} color="#000" textAlign="center" fontSize={RF(4.0)} fontFamily="NunitoExtraBold" inline={true} />
                </View>
            </View>
        )

        let layout = (
            <View style={{ width: "100%" }}>
                <View style={{ width: '100%', alignItems: 'center' }}>
                    <Heading text="Thank you for submitting your pre-screening report today." color="#a70f14" textAlign="center" fontSize={RF(4.0)} fontFamily="NunitoExtraBold" inline={true} />
                </View>
                {pin}
            </View>
        )

        if(this.state.highTemprature) {
            layout = (
                <View style={{ width: "100%" }}>
                    <View style={{ width: '100%', alignItems: 'center' }}>
                        <Heading text="Your temprature is high. Please consult your caretaker." color="#a70f14" textAlign="center" fontSize={RF(4.0)} fontFamily="NunitoExtraBold" inline={true} />
                    </View>
                    {pin}
                </View>
            )
        }

        if(this.state.sick) {
            layout = (
                <View style={{ width: "100%" }}>
                    <View style={{ width: '100%', alignItems: 'center' }}>
                        <Heading text="You have answered one of your questions as yes. Please consult your caretaker." color="#a70f14" textAlign="center" fontSize={RF(4.0)} fontFamily="NunitoExtraBold" inline={true} />
                    </View>
                    {pin}
                </View>
            )
        }

        if (this.state.loading) {
            layout = <ActivityIndicator />
        }

        return (
            <View style={{ flex: 1, backgroundColor: "#FFF" }}>
                <SafeAreaView style={{ flex: 1, flexDirection: "column" }}>
                    <View style={{ width: "100%", marginTop: 20 }}>
                        <View style={{ width: "100%" }}>
                            <Image source={require('../../assets/img/icon.jpg')} resizeMode="contain" style={{ width: "100%", height: 120 }} />
                        </View>
                    </View>
                    <View style={{ flexGrow: 1, justifyContent: 'center', alignItems: "center", flexDirection: "column", paddingLeft: 20, paddingRight: 20 }}>
                        {layout}
                    </View>
                    <View style={{ width: "100%", padding: 20 }}>
                        <TouchableOpacity onPress={() => this.props.navigation.navigate('Landing')}>
                            <View style={{ width: '100%', height: 50, borderRadius: 10, borderWidth: 2, borderColor: "#149f84", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                <Heading text="New" color="#999" textAlign="center" fontSize={RF(3.0)} fontFamily="NunitoExtraBold" inline={true} marginRight={10} />
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{ width: "100%", marginBottom: 15, paddingLeft: 20, paddingRight: 20 }}>
                        <Heading text="By completing this form process you agree to BlipperSCREEN's Terms of Use and acknowledge you have read the Privacy Policy." color="#999" textAlign="left" fontSize={RF(2.2)} fontFamily="NunitoRegular" inline={true} />
                    </View>
                </SafeAreaView>
            </View>
        );
    }

}
